import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { ExplosionEmoji } from '@contra/icons/emojis';

type SampleRegularModalProps = CommonTemplateProps & {
  readonly description: string;
  readonly title: string;
};

export const SampleRegularModal = ({
  closeModal,
  description,
  isOpen,
  title,
}: SampleRegularModalProps) => {
  const icon = <ExplosionEmoji size={24} />;

  return (
    <ModalTemplateWrapper
      ariaLabel={title}
      ctaOptions={{
        primaryCTA: {
          handleOnClick: () => {},
          label: 'Primary',
        },
        secondaryCTA: {
          handleOnClick: closeModal,
          label: 'Secondary',
        },
      }}
      desktopModalSize="md"
      headerText={title}
      icon={icon}
      isOpen={isOpen}
      onClose={closeModal}
      subheaderText={description}
    />
  );
};
